import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'nucleus-hotspots',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      hotspots: z.coerce.number().min(1),
      instructions: z.string().min(1, { message: 'Please provide hotspot information.' }),
    }),
  },
  {
    name: 'Nucleus Hotspots',
    short: 'Let viewers interact with the space, explore product details, or access extra context directly inside the 3D tour.',
    thumbnail: 'tenant/twt/nucleus/hotspot.jpg',
    color: '#8e51b1',
    tenant: TenantId.TWIST_TOURS,
    images: [],
  },
);
